$('.testimonials').slick({
    dots: false,
    infinite: true,
    arrows: false,
    prevArrow: '',
    slide: '.testimonials .testimonial',
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true
});
